// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SocialNetworkLinks{align-items:center;display:flex}.SocialNetworkLinks__label{color:#124c86;font-weight:700}.SocialNetworkLinks__items{display:flex;flex-wrap:wrap}@media(min-width:768px){.SocialNetworkLinks__items{align-items:center}}.SocialNetworkLinks__item{align-items:center;color:#124c86;display:flex}.SocialNetworkLinks__item>svg{height:2rem;width:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
